import { render, staticRenderFns } from "./DatasetDetailDlg.vue?vue&type=template&id=1fdb3aea&scoped=true&"
import script from "./DatasetDetailDlg.vue?vue&type=script&lang=js&"
export * from "./DatasetDetailDlg.vue?vue&type=script&lang=js&"
import style0 from "./DatasetDetailDlg.vue?vue&type=style&index=0&id=1fdb3aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdb3aea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VContainer,VDataTable,VDialog,VTextField})
